import axios from 'axios'
const isNewVersion = () => {
  let url = `//${window.location.host}/static/version.json?t=${new Date().getTime()}`;
  axios.get(url).then(res => {
    if (res.status === 200) {
      const configVersion = res.data.version  // 当前开发版本
      const localVersion = localStorage.getItem('webSiteVersion') // 浏览器本地存储版本

      

      if(localVersion) {
        // 版本存在，但不是最新的版本。
        if(localVersion != configVersion) {
          // 版本不同则刷新页面
          // alert('监测版本号不一致，需要更新...')
          localStorage.setItem('webSiteVersion', configVersion);
          window.location.reload();
        }
      } 
      else {
        // 不存在版本
        localStorage.setItem('webSiteVersion', configVersion);
        window.location.reload()
      }
    }
  })
}
 
export default {
  isNewVersion
}